import { api } from "./api";

export const transferApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTransfers: builder.query({
      query: () => "api/Stock/TransForm",
      providesTags: ["transfers"],
    }),
    getTransferByTransDoc: builder.query({
      query: (transDoc) => `api/Stock/TransForm?TransDoc=${transDoc}`,
      providesTags: ["transfers"],
    }),
    addTransfer: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/TransForm",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["transfers"],
    }),
    editTransfer: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/TransForm",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["transfers"],
    }),
    deleteTransfer: builder.mutation({
      query: (transId) => ({
        url: `api/Stock/TransForm?TransID=${transId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["transfers"],
    }),
  }),
});

export const {
  useGetTransfersQuery,
  useLazyGetTransferByTransDocQuery,
  useAddTransferMutation,
  useEditTransferMutation,
  useDeleteTransferMutation,
} = transferApi;
